import React from 'react';

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction
} from '@epoch-ui/components/AlertDialog/alert-dialog';

interface UpdateRequiredQuestionConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

/**
 * Confirmation dialog displayed when marking an existing questionnaire question as required.
 * Warns users that confirmed guest statuses will be changed to incomplete since they may not
 * have answered this question when it was optional.
 *
 * @param open - Controls the visibility of the dialog
 * @param onOpenChange - Callback fired when the dialog open state changes
 * @param onConfirm - Callback fired when the user confirms updating the question to required
 */
export const UpdateRequiredQuestionConfirmationDialog: React.FC<
  UpdateRequiredQuestionConfirmationDialogProps
> = ({ open, onOpenChange, onConfirm }) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="tw-max-w-[400px] tw-gap-5">
        <AlertDialogHeader>
          <AlertDialogTitle className="tw-mb-0 tw-text-2xl tw-font-medium tw-leading-8">
            Guest status change
          </AlertDialogTitle>
        </AlertDialogHeader>

        <div className="tw-space-y-4">
          <p className="tw-text-content-primary tw-text-sm">
            Confirmed guest statuses will be changed to incomplete when you make an existing
            question required.
          </p>

          <p className="tw-text-content-primary tw-text-sm">You can’t undo this action</p>
        </div>

        <AlertDialogFooter className="tw-flex tw-justify-end tw-gap-3">
          <AlertDialogCancel className="tw-rounded-xl" size="sm">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction className="tw-rounded-xl" onClick={onConfirm} size="sm">
            Update question
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
